import request from './request.js'

// /internalAgreement/checkRunnable
export function checkRunnable(data){
  return request({
    url: 'internalAgreement/checkRunnable',
    method: 'post',
    params: data
  });
}

// /internalAgreement/getSettingData
export function getSettingData(data){
  return request({
    url: 'internalAgreement/getSettingData',
    method: 'post',
    params: data
  });
}

// /internalAgreement/updateAllowSign
export function updateAllowSign(data){
  return request({
    url: 'internalAgreement/updateAllowSign',
    method: 'post',
    params: data
  });
}

// /internalAgreement/updateSettingData
export function updateSettingData(data){
  return request({
    url: 'internalAgreement/updateSettingData',
    method: 'post',
    params: data
  });
}

// /internalApplication/getApplyData
export function getApplyData(data){
  return request({
    url: 'internalApplication/getApplyData',
    method: 'post',
    params: data
  });
}

// /internalApplication/getPendingCount
export function getPendingCount(data){
  return request({
    url: 'internalApplication/getPendingCount',
    method: 'post',
    params: data
  });
}

// /internalApplication/getOneData
export function getApplicationOneData(data) {
  return request({
    url: 'internalApplication/getOneData',
    method: 'post',
    params: data  
  });
}

// /internalApplication/reject
export function rejectApplication(data){
  return request({
    url: 'internalApplication/reject',
    method: 'post',
    params: data
  });
}

// /internalApplication/sendVerifyCode
export function sendVerifyCode(data){
  return request({
    url: 'internalApplication/sendVerifyCode',
    method: 'post',
    params: data
  });
}

// /internalApplication/verifyCodeSign
export function verifyCodeSign(data){
  return request({
    url: 'internalApplication/verifyCodeSign',
    method: 'post',
    params: data
  });
}

// /internalApplication/sign
export function sign(data){
  return request({
    url: 'internalApplication/sign',
    method: 'post',
    params: data
  });
}

// /internalAgreement/getData
export function getAgreementData(data){
  return request({
    url: 'internalAgreement/getData',
    method: 'post',
    params: data
  });
}

// /internalAgreement/update
export function updateAgreement(data){
  return request({
    url: 'internalAgreement/update',
    method: 'post',
    params: data
  });
}

// /internalAgreement/getAgreementWithUpload
export function getAgreementWithUpload(data){
  return request({
    url: 'internalAgreement/getAgreementWithUpload',
    method: 'post',
    params: data
  });
}

// /internalAgreement/getAgreementFile
export function getAgreementFile(data){
  return request({
    url: 'internalAgreement/getAgreementFile',
    method: 'post',
    params: data
  });
}

export function insertDepartmentAgreement(data) {
  return request({
      url: 'departmentprojectagreement/insert',
      method: 'post',
      params: data
  })
}

export function insertDepartmentAgreementGeneral(data) {
  return request({
      url: 'departmentagreement/insert',
      method: 'post',
      params: data
  })
}

export function updateDepartmentAgreement(data) {
  return request({
      url: 'departmentprojectagreement/update',
      method: 'post',
      params: data
  })
}

export function getDepartmentAgreementDataGeneral(data) {
  return request({
      url: 'departmentagreement/getData',
      method: 'post',
      params: data
  })
}

export function deleteDepartmentAgreementFile(data) {
  return request({
      url: 'departmentprojectagreement/delete',
      method: 'post',
      params: data
  })
}

export function deleteDepartmentAgreementFileGeneral(data) {
  return request({
      url: 'departmentagreement/delete',
      method: 'post',
      params: data
  })
}

export function updateDepartmentExpiryDateTime(data) {
  return request({
      url: 'departmentprojectagreement/updateExpiryDateTime',
      method: 'post',
      params: data
  })
}

export function updateDepartmentExpiryDateTimeGeneral(data) {
  return request({
      url: 'departmentagreement/updateExpiryDateTime',
      method: 'post',
      params: data
  })
}

export function insertLog(data){
  return request({
    url: 'internalLog/insert',
    method: 'post',
    params: data
  });
}
export function getLogData(data){
  return request({
    url: 'internalLog/getData',
    method: 'post',
    params: data
  });
}
export function insertAmendment(data){
  return request({
    url: 'internalAmendment/insert',
    method: 'post',
    params: data
  });
}
export function getAmendmentData(data){
  return request({
    url: 'internalAmendment/getData',
    method: 'post',
    params: data
  });
}
export function getProjectAgreements(data){
  return request({
    url: 'internalAgreement/getProjectAgreements',
    method: 'post',
    params: data
  });
}

export function updateCommission(data){
  return request({
    url: 'internalAgreement/updateCommission',
    method: 'post',
    params: data
  });
}

export function updateCommissionForAllTeam(data){
  return request({
    url: 'internalAgreement/updateCommissionForAllTeam',
    method: 'post',
    params: data
  });
}

//department set all rest project commissions
export function setDeptRestAllCommissions(data) {
  return request({
      url: 'departmentProject/showAllToDepartment',
      method: 'post',
      params: data
  });
}



// WEBPACK FOOTER //
// ./src/api/internalApi.js